;(function() {
/* @ngInject */
function LoginController(UserService, $window) {
    let vm = this;
    let server = UserService;

    vm.loginForm = {};
    vm.user = {};
    vm.errorMessage = null;
    vm.loginUser = loginUser;
    vm.changePasswordInputType = changePasswordInputType;
    vm.passwordInputType = 'password';

    server.getLoggedUser().then(onLoggedUserLoad);

    function loginUser() {
        if(vm.loginForm.$invalid) {
            vm.submitted = true;
        } else {
            vm.showSpinnerPopover = true;
            vm.showSpinner = true;
            server.login({email: vm.user.email, password: vm.user.password}).then(({success, data}) => {
                if (success) {
                    vm.errorMessage = null;
                    server.getLoggedUser().then(onLoggedUserLoad);
                } else {
                    vm.errorMessage = "bad";
                }
            }).catch(function (e) {
                vm.errorMessage = "bad";
            }).finally(_ => {
                vm.showSpinnerPopover = false;
                vm.showSpinner = false;
            });
        }
    }

    function changePasswordInputType() {
        return vm.passwordInputType === 'password' ? vm.passwordInputType = 'text' : vm.passwordInputType = 'password';
    }

    function onLoggedUserLoad(user) {
        if (user) {
            $window.location = "/";
        }
    }
}

angular.module("firmaren")
    .controller("LoginController", LoginController);
}());
